'use client'

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

// Suma los textos de la app (locales/<idioma>/caminos-neo-riemannianos.json) al namespace `apps` de la instancia de
// i18n del layout raiz, con las claves apps:caminos_neo_riemannianos.*. Tiene que pasar ANTES de pintar la ruta:
// react-i18next no vuelve a pintar cuando se agrega un bundle despues. Es idempotente, asi que no importa si React
// repite el render. Calcado de TextosColecciona.
export default function TextosCaminos({ textos, children }) {
  const { i18n } = useTranslation()

  useMemo(() => {
    i18n.addResourceBundle(i18n.language, 'apps', textos, true, true)
  }, [i18n, textos])

  return children
}
